/**
 * Minaccia-Misura — coreBOS `ThreatsMeasures` (68x) on evo-gdpr.evolutivo.it.
 * Harvested from evo-mcp-limitless@origin/evo-policies by scripts/harvest/gen_descriptors.py.
 * Frameworks: gdpr,nis2. Type sources per field: docs/harvest-report.md.
 * Regenerate instead of hand-editing; hand edits belong in the generator's SPEC.
 */
export const measureDescriptor = {
    slug: 'cmp_measure',
    kind: 'document',
    label: { singular: 'Minaccia-Misura', plural: 'Minacce-Misure' },
    table: 'compliance_measure',
    idStrategy: 'sha256',
    fields: [
        { name: 'threatsmeasurename', type: 'text', label: 'Threatsmeasurename', required: true },
        { name: 'threatsmeasure_id', type: 'text', label: 'Threatsmeasure id' },
        { name: 'framework_tags', type: 'text', label: 'Framework tags' },
        { name: 'csf_function', type: 'text', label: 'Csf function' },
        { name: 'measure_id', type: 'text', label: 'Misura' },
        { name: 'measure_category', type: 'text', label: 'Measure category' },
        { name: 'implementation_status', type: 'text', label: 'Stato' },
        { name: 'tmimpact', type: 'text', label: 'Tmimpact' },
        { name: 'theoretical_impact', type: 'text', label: 'Theoretical impact' },
        { name: 'current_risk_score', type: 'number', label: 'Current risk score' },
        { name: 'critical_gap_score', type: 'number', label: 'Gap Score' },
        { name: 'reccomendations', type: 'text', label: 'Reccomendations' },
        { name: 'description', type: 'text', label: 'Description' },
        { name: 'threatsmeasuresname', type: 'text', label: 'Nome', required: true },
        { name: 'measure_name', type: 'text', label: 'Nome Misura' },
        { name: 'task_layer', type: 'text', label: 'Layer' },
    ],
    relations: [
        { name: 'audit_link', kind: 'belongsTo', target: 'cmp_audit' },
        { name: 'tmlinktothreats', kind: 'belongsTo', target: 'cmp_threat' },
        { name: 'threat_link', kind: 'belongsTo', target: 'cmp_threat' },
        { name: 'assigned_user', kind: 'belongsTo', target: 'user', toEntitySpine: true },
    ],
    behaviors: { ownership: true, audit: true, softDelete: true, tenantScoped: true },
    ui: { mode: 'generated', icon: 'SafetyCertificateOutlined', navGroup: 'Rischi' },
};
